import React from 'react';
import ArrowBox from '../../../../components/shareable/arrowBox';
import { LENGTH_LIMIT_MAX_FT } from '../../../../utils/defaultValues';

const ControlsRow = ({
  handleClearBox,
  infeedLength,
  setInfeedLength,
  setLengthLimitMessage,
  setShowLengthLimitModal,
  handleArrowClick,
  items,
  isRotatedArrow,
  orientation,
  outfeedLength,
  setOutfeedLength,
  arrowRef,
  isGeneratingPdf,
  setIsGeneratingPdf
}) => {
  const isSwapped = orientation === 'right-to-left';
  
  // Define the labels based on whether we're swapped or not
  const leftLabel = isSwapped ? "Outfeed (FT)" : "Infeed (FT)";
  const leftButtonText = isSwapped ? "Clear Outfeed" : "Clear Infeed";
  const rightLabel = isSwapped ? "Infeed (FT)" : "Outfeed (FT)";
  const rightButtonText = isSwapped ? "Clear Infeed" : "Clear Outfeed";
  
  return (
    <div className="flex items-center justify-between mb-3 pt-4 pb-4">
      {/* Left Section (Infeed/Outfeed based on orientation) */}
      <div className="flex items-center gap-1 -mb-3">
        <div className='mt-0'>
        <button
          onClick={() => handleClearBox('left')}
          className="w-28 h-[30px] text-[15px] font-medium text-white bg-red-600 rounded hover:bg-red-700 transition text-center whitespace-nowrap"
        >
          {leftButtonText}
        </button>
        </div>
        <div className="relative">
          <label className="absolute -top-6 left-0 text-[15px] text-gray-700 mb-1">{leftLabel}</label>
          <input
            type="number"
            className="w-28 h-[30px] px-1 text-[15px] border border-gray-300 rounded focus:ring-red-400 focus:border-red-400 bg-gray-100 cursor-default text-center"
            value={infeedLength}
            onChange={(e) => {
              const value = parseFloat(e.target.value) || 0;
              if (value > LENGTH_LIMIT_MAX_FT) {
                setLengthLimitMessage(`Maximum length is ${LENGTH_LIMIT_MAX_FT}ft`);
                setShowLengthLimitModal(true);
                setInfeedLength(LENGTH_LIMIT_MAX_FT);
              } else {
                setInfeedLength(value);
              }
            }}
            min="0"
            max={LENGTH_LIMIT_MAX_FT}
            step="0.1"
            readOnly
          />
        </div>
      </div>

      {/* Arrow Box */}
      <div ref={arrowRef} id="arrow-module" onClick={handleArrowClick} className="cursor-pointer hover:scale-105 -mb-3" title="Toggle options" >
        <ArrowBox items={items} isRotated={isRotatedArrow} orientation={orientation} isGeneratingPdf={isGeneratingPdf} setIsGeneratingPdf={setIsGeneratingPdf} />
      </div>

      {/* Right Section (Outfeed/Infeed based on orientation) */}
      <div className="flex items-center gap-1 -mb-3">
        <div className="relative">
          <label className="absolute -top-6 left-0 text-[15px] text-gray-700 mb-1">{rightLabel}</label>
          <input
            type="number"
            className="w-28 h-[30px] px-1 text-[15px] border border-gray-300 rounded focus:ring-red-400 focus:border-red-400 bg-gray-100 cursor-default text-center"
            value={outfeedLength}
            onChange={(e) => {
              const value = parseFloat(e.target.value) || 0;
              if (value > LENGTH_LIMIT_MAX_FT) {
                setLengthLimitMessage(`Maximum length is ${LENGTH_LIMIT_MAX_FT}ft`);
                setShowLengthLimitModal(true);
                setOutfeedLength(LENGTH_LIMIT_MAX_FT);
              } else {
                setOutfeedLength(value);
              }
            }}
            min="0"
            max={LENGTH_LIMIT_MAX_FT}
            step="0.1"
            readOnly
          />
        </div>
        <div className='mt-0'>
        <button
          onClick={() => handleClearBox('right')}
          className="w-28 h-[30px] text-[15px] font-medium text-white bg-red-600 rounded hover:bg-red-700 transition text-center whitespace-nowrap"
        >
          {rightButtonText}
        </button>
        </div>
      </div>
    </div>
  );
};

export default ControlsRow;

